import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import { withRouter } from "../HOC/withRouter";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import { apiURL, fetchLedgerMaster, fetchPayment } from "./API";
import {
  applyTrimOnObjectValues,
  getRowColData,
  get_YMD_from_SYS,
  isValidItem,
  validatedate_min_max,
  applyNumberToRow,
  copyRowsAllCols,
  getRowData,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import PaymentModeTable from "./PaymentModeTable";
import LedgerMaster from "./LedgerMaster";
import MoreInfoTextEditor from "./MoreInfoTextEditor";

class PaymentEntry extends Component {
  state = {
    LedgerGroup: [],
    LedgerGroupList: [],
    defaultSetting: [],
    columns1: [
      // { id: "Action", label: "Search", name: "Search" },
      { id: "vac_ledgername", label: "Payment Mode Ledger" },
      {
        id: "dec_amount",
        label: "Amount",
        type: "CtTxtAmt",
        CtrlProps: { value: "", width: 100, maxLength: 10 },
      },
      {
        id: "vac_chequeno",
        label: "Cheque No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 6 },
      },
      {
        id: "vac_referenceno",
        label: "Reference No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 100 },
      },
      {
        id: "dat_transactiondate",
        label: "Transaction Date",
        type: "CtDtp",
        CtrlProps: { value: "", maxLength: 20 },
      },
      {
        id: "vac_remark",
        label: "Remark",
        type: "CtMultiLineText",
        CtrlProps: { value: "", width: 100, maxLength: 1000 },
      },
    ],

    searchData: {
      invoiceno: "",
      invoiceyear: "",
      outstandingamt: "",
      paidamount: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,

    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "PaymentEntry:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "PaymentEntry:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Payment == "R" ||
          this.props.userPrivilege.Payment == "W",
      },
    ],
    keyColumn: [
      "bint_srno",
      "vac_CompanyName",
      "vac_LegderName",
      "vac_LegderType",
      "int_LegderCode",
      "dec_OpeningBalance",
      "vac_BalanceSheet",
      "vac_trading",
      "vac_profitloss",
    ],
    formData: {
      edit_expensesrno: "",
      txtVoucherNo: "",
      dtpDate: get_YMD_from_SYS(new Date()),
      cmbLedgerGroup: "Supplier",
      cmbLedger: this.props.cmbSupplier || "",
      // cmbLedger: "",
      txtAmount: this.props.txtAdvPayment || "",
      txtRemark: "",
    },
    PaymentData: [],
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],
    GeneralSettingList: [],
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    // document.title = "RiTe Account : Payment Entry";
    this.props.setActiveMenu("PaymentEntry");
    this.ShortCut();
    this.setSearchColumns();
    this.props.verifyUserID(() => {
      this.getInfo(true);
    });
    // const cmbLedgerElement = document.getElementById("cmbLedger");
    // cmbLedgerElement.addEventListener("focus", this.handleFocus);
    document.addEventListener("keydown", this.handleKeyDown);
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
    document.removeEventListener("keydown", this.handleKeyDown);
    this.removeKeyboardShortCuts();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickSave: this.SavePayment,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: this.onDeleteClick,
        handleOnClickRemark: () => {
          this.openRichTextBox(
            "Remark",
            "Remark",
            this.state.formData.txtRemark
          );
        },
      }),
    });
  };
  //#endregion Component

  //#region handle

  // handleSaveDown = (event) => {
  //   if (event.altKey && event.keyCode === 83) {
  //     const saveButton = document.getElementById("savePayment");
  //     if (saveButton) {
  //       saveButton.click();
  //     }
  //   }
  // };

  // handleFocus = () => {
  //   document.addEventListener("keydown", this.handleKeyDown);
  // };

  handleKeyDown = (event) => {
    if (event.keyCode === 45) {
      this.onAddClickLedger();
    } else if (event.altKey && event.keyCode === 83) {
      const saveButton = document.getElementById("savePayment");
      if (saveButton) {
        saveButton.click();
      }
    }
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchInputChangeTrim = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value.trim(),
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.invoiceno.length === 0 ||
            (row["invoiceno"] &&
              row["invoiceno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.invoiceno.toLowerCase()))) &&
          (this.state.searchData.invoiceyear.length === 0 ||
            (row["invoiceyear"] &&
              row["invoiceyear"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.invoiceyear.toLowerCase()))) &&
          (this.state.searchData.outstandingamt.length === 0 ||
            (row["outstandingamt"] &&
              row["outstandingamt"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.outstandingamt.toLowerCase()
                ))) &&
          (this.state.searchData.paidamount.length === 0 ||
            (row["paidamount"] &&
              row["paidamount"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.paidamount.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        /*  if (e.target.name === "txtAmount") {
          console.log("DHOC : this.state.rows",this.state.rows);
          let rows = this.state.rows.map((row, index) => {
            if (
              row.chk_paymentmode == true
              // row.vac_ledgername === this.state.defaultSetting.vac_ledgername
            ) {
              row.dec_amount = this.state.formData.txtAmount;
            }
            return row;
          });
          console.log("DHOC : rows",rows);
          this.setState({ rows }, () => { console.log('rows on handleOnChange', rows) });
          // console.log("vac_ledgername", vac_ledgername);
        } */
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (values) => {
    // console.log("values", values);
    const bint_srno = values[0].value,
      cmbCompanyName = values[1].value,
      txtLegderName = values[2].value,
      cmbLegderType = values[3].value,
      txtLegderCode = values[4].value,
      txtOpeningBalance = values[5].value,
      cmbBalanceSheet = values[6].value,
      chktrading = values[7].value,
      chkprofitloss = values[8].value,
      actionName = values[0].actionName;
    if (actionName === "Edit") {
      this.setState({
        formData: {
          ...this.state.formData,
          bint_srno,
          cmbCompanyName,
          txtLegderName,
          cmbLegderType,
          txtLegderCode,
          txtOpeningBalance,
          cmbBalanceSheet,
          chktrading,
          chkprofitloss,
        },
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete  : " + bint_srno + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLedgerDetail(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      let rows = this.state.rows.filter((row) => {
        if (
          row.bint_srno !== bint_srno &&
          row.vac_CompanyName !== cmbCompanyName &&
          row.vac_LegderName !== txtLegderName &&
          row.vac_LegderType !== cmbLegderType &&
          row.int_LegderCode !== txtLegderCode &&
          row.dec_OpeningBalance !== txtOpeningBalance &&
          row.vac_BalanceSheet !== cmbBalanceSheet &&
          row.vac_trading !== chktrading &&
          row.vac_profitloss !== chkprofitloss
        )
          return row;
      });
      const rowsCount = rows.length;
      this.setState({ rows, rowsCount });
    }
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length });
  };

  openPaymentPrint = (bint_expensesrno) => {
    this.props.notifyProcessing();

    let PrintFormat = getRowData(
      this.state.GeneralSettingList,
      "vac_key",
      "Print Format"
    );
    let Op = "";
    // console.log("PrintFormat", PrintFormat);
    if (PrintFormat["vac_value"] === "Gujarati Data") {
      Op = "VoucherPrint_HTML";
    } else {
      Op = "VoucherPrint";
    }

    let reqData = [
      { name: "Op", value: Op },
      { name: "bint_acyear", value: localStorage.getItem("ACY") },
      { name: "bint_acid", value: localStorage.getItem("acid") },
      { name: "bint_expensesrno", value: bint_expensesrno },
      { name: "bolPrintSingatureStamp", value: 1 },
    ];

    // Create a query string from the request data
    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    // Set the URL of the popup window
    let popupURL = apiURL + "expenseentrydetail.php?" + queryString;

    // Open the popup window
    window.open(
      popupURL,
      "PaymentList",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
  };
  //#endregion handle

  //#region function
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  // ShortCut = () => {
  //   this.setState({
  //     removeKeyboardShortCuts: setKeyboardShortcuts(
  //       this.SavePayment,
  //       this.clearInfo,
  //       () => {
  //         this.onDeleteClick();
  //       }
  //     ),
  //   });
  // };

  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["cmbLedgerGroup"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "invoiceno",
        label: "Invoice No",
        value: this.state.searchData.invoiceno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "invoiceyear",
        label: "Invoice Year",
        value: this.state.searchData.invoiceyear,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "outstandingamt",
        label: "Outstanding Amount",
        value: this.state.searchData.outstandingamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "paidamount",
        label: "Paid Amount",
        value: this.state.searchData.paidamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  validateLedgerGroup = () => {
    let result = false;
    if (this.state.formData.cmbLedgerGroup.length > 0) {
      this.state.LedgerGroupList.map((row) => {
        if (row.vac_groupname === this.state.formData.cmbLedgerGroup) {
          result = true;
        }
      });
    }
    return result;
  };

  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    if (this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (row.dec_amount !== null && row.dec_amount !== undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
      if (dec_amount == Number(this.state.formData.txtAmount)) {
        result = true;
      } else if (dec_amount === 0) {
        this.props.toastErrorMsg("Enter Payment Mode Amount", "txtAmount");
      } else {
        this.props.toastErrorMsg(
          "Payment Amount must be same as Total of Payment Mode Amount",
          "txtAmount"
        );
      }
    } else {
      result = true;
    }
    return result;
  };

  validateLedger = () => {
    let result = false;
    if (this.state.formData.cmbLedger.length > 0) {
      this.state.LedgerGroup.map((row) => {
        if (row.vac_ledgername === this.state.formData.cmbLedger) {
          result = true;
        }
      });
    }
    return result;
  };

  validatePayment = () => {
    let result = false;
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props
      ) === false
    ) {
      return false;
    } else if (
      this.state.formData.cmbLedgerGroup.length > 0 &&
      this.validateLedgerGroup() === false
    ) {
      this.props.toastErrorMsg("Select valid Ledger Group", "cmbLedgerGroup");
    } else if (this.state.formData.cmbLedger.length <= 0) {
      this.props.toastErrorMsg("Select Ledger Name", "cmbLedger");
    } else if (this.validateLedger() === false) {
      this.props.toastErrorMsg("Select valid Ledger Name", "cmbLedger");
    } else if (this.state.formData.txtAmount.length <= 0) {
      this.props.toastErrorMsg("Enter Amount", "txtAmount");
    } else if (this.state.rows.length === 0) {
      this.props.toastErrorMsg("No Payment details found");
    } else {
      result = true;
    }
    // console.log("validatePayment result",result);
    return result;
  };

  clearInfo = () => {
    const edit_expensesrno = "",
      txtVoucherNo = "",
      dtpDate = get_YMD_from_SYS(new Date()),
      cmbLedgerGroup = "Supplier",
      cmbLedger = "",
      txtAmount = "",
      txtRemark = "";
    const PaymentData = this.state.rows.map((item) => ({
      ...item,
      dec_amount: "",
      vac_chequeno: "",
      vac_referenceno: "",
      dat_transactiondate: "",
      vac_remark: "",
    }));
    this.setState(
      {
        formData: {
          ...this.state.formData,
          edit_expensesrno,
          txtVoucherNo,
          dtpDate,
          cmbLedgerGroup,
          cmbLedger,
          txtAmount,
          txtRemark,
        },
        rows: PaymentData,
        PaymentData: [],
        rowsPaymentMode: copyRowsAllCols(
          this.state.LedgerGroup,
          this.state.PaymentmodeListCols
        ),
      },
      () => {
        document.getElementById("dtpDate").focus();
      }
    );
  };

  SavePayment = (bolexpenseprint = false) => {
    if (this.validatePayment() && this.validatePaymentModeAmount()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveExpense_Payment",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          bint_expensesrno: this.state.formData.txtVoucherNo,
          dat_date: this.state.formData.dtpDate,
          vac_groupname: this.state.formData.cmbLedgerGroup,
          vac_ledgername: this.state.formData.cmbLedger,
          dec_amount: this.state.formData.txtAmount,
          vac_remark: this.state.formData.txtRemark,
          bint_vouno: 0,
          PaymentData: this.state.rows,
          dat_fromdate: this.props.dtpFromDate,
          dat_todate: this.props.dtpToDate,
        };
        fetchPayment(reqData)
          .then((res) => {
            // console.log("reqData", reqData);
            this.props.updateProcessing(res.data.msgType, res.data.message);
            // console.log("res.data.msgType", res.data.msgType);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = 0;
              if (res.data.ExpenseList && res.data.ExpenseList.length > 0) {
                rows = res.data.ExpenseList;
                rowsCount = rows.length;
              }
              let bint_expensesrno = 0;
              if (
                res.data.bint_expensesrno &&
                Number(res.data.bint_expensesrno) > 0
              ) {
                bint_expensesrno = res.data.bint_expensesrno;
              }
              if (bolexpenseprint) {
                this.openPaymentPrint(bint_expensesrno);
              }
              this.getInfo();
              this.props.refreshPaymentList(rows, rowsCount);
              this.clearInfo();
              // this.setState(() => {
              //   if (bolexpenseprint) {
              //     this.openPaymentPrint();
              //   }
              //   this.props.refreshPaymentList(rows, rowsCount);

              //   this.clearInfo();
              // });
            }
          })

          .catch((error) => {
            console.log("Unknown error occurred in SavePayment.", error);
          });
      });
    }
  };

  getInfo = (useProps = false) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "ExpenseData",
        bint_acyear: localStorage.getItem("ACY"),
        bint_acid: localStorage.getItem("acid"),
        // edit_expensesrno: this.state.formData.edit_expensesrno,
        edit_expensesrno:
          useProps && this.props.bint_expensesrno
            ? this.props.bint_expensesrno
            : 0,
      };
      fetchPayment(reqData)
        .then((res) => {
          dataLoadStatus = true;
          // let LedgerGroup = res.data.LedgerNameList;
          // console.log("LedgerGroup", LedgerGroup);
          // let LedgerGroupList = getRowColData(LedgerGroup, "vac_groupname");
          let LedgerGroup = [];
          let LedgerGroupList = [];
          let rows = [],
            PaymentLedgerNameList = [],
            rowsCount = rows.length,
            PaymentData = [];
          let defaultSetting = res.data.DefaultEntrySettingList[0];
          let GeneralSettingList = res.data.GeneralSettingList;

          if (res.data.LedgerNameList && res.data.LedgerNameList.length > 0) {
            LedgerGroup = res.data.LedgerNameList;
            LedgerGroupList = getRowColData(LedgerGroup, "vac_groupname");
          }
          if (
            res.data.PaymentLedgerNameList &&
            res.data.PaymentLedgerNameList.length > 0
          ) {
            rows = res.data.PaymentLedgerNameList;
            rowsCount = rows.length;
            PaymentLedgerNameList = res.data.PaymentLedgerNameList;
          }
          if (res.data.PaymentData && res.data.PaymentData.length > 0) {
            PaymentData = res.data.PaymentData;
          }
          /* if (res.data.PaymentData && res.data.PaymentData.length > 0) {
            rows = res.data.PaymentData;
            rowsCount = rows.length;
          } else {
            if (
              res.data.PaymentLedgerNameList &&
              res.data.PaymentLedgerNameList.length > 0
            ) {
              rows = res.data.PaymentLedgerNameList;
              PaymentLedgerNameList = res.data.PaymentLedgerNameList;
            }
          } */
          this.setState(
            {
              dataLoadStatus,
              LedgerGroup,
              LedgerGroupList,
              rows,
              rowsCount,
              defaultSetting,
              PaymentData,
              GeneralSettingList,
            },
            () => {
              if (useProps) {
                this.onEditPaymentEntry(res.data.PaymentData, rows);
              }
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in getInfo.", error);
        });
    });
    /* if (useProps) {
      this.onEditPaymentEntry();
    } */
    document.getElementById("dtpDate").focus();
  };

  onEditPaymentEntry = (PaymentData, rows) => {
    if (
      this.props.bint_expensesrno &&
      Number(this.props.bint_expensesrno) > 0
    ) {
      let rowsCount = 0;
      if (this.props.EditPaymentData && this.props.EditPaymentData.length > 0) {
        let EditPaymentData = this.props.EditPaymentData;
        if (PaymentData && PaymentData.length > 0) {
          PaymentData.map((odd) => {
            let isFound = 0;
            rows.map((rod) => {
              if (rod.vac_ledgername === odd.vac_ledgername) {
                // rod.vac_value = odd.vac_value;
                rod.dec_amount = odd.dec_amount;
                rod.vac_chequeno = odd.vac_chequeno;
                rod.vac_referenceno = odd.vac_referenceno;
                rod.dat_transactiondate = odd.dat_transactiondate;
                rod.vac_remark = odd.vac_remark;
                // rod.vac_groupname = odd.vac_groupname;
                isFound++;
              }
            });
            if (isFound === 0) {
              rows.push({
                vac_ledgername: odd.vac_ledgername,
                dec_amount: odd.dec_amount,
                vac_chequeno: odd.vac_chequeno,
                vac_referenceno: odd.vac_referenceno,
                dat_transactiondate: odd.dat_transactiondate,
                vac_remark: odd.vac_remark,
                // vac_groupname: odd.vac_groupname,
                // bint_displayorderno: rowsPaymentMode.length + 1,
              });
            }
          });
          // rows = rows.map((row) => {
          //   return { ...row, dec_amount: row.dec_amount != '' && row.dec_amount != undefined && row.dec_amount != null ? Number(row.dec_amount) : '' }
          // })
          // rows = applyNumberToRow(rows, ['dec_amount'])
          rowsCount = rows.length;
        }
        this.setState(
          {
            rows,
            rowsCount,
            formData: {
              ...this.state.formData,
              edit_expensesrno: EditPaymentData[0].bint_expensesrno,
              txtVoucherNo: EditPaymentData[0].bint_expensesrno,
              dtpDate: EditPaymentData[0].dat_date,
              cmbLedgerGroup: EditPaymentData[0].vac_groupname,
              cmbLedger: EditPaymentData[0].vac_ledgername,
              txtAmount: Number(EditPaymentData[0].dec_amount),
              txtRemark: EditPaymentData[0].vac_remark,
            },
          },
          () => {
            // console.log("this.state.defaultSetting", this.state.defaultSetting);
            document.getElementById("dtpDate").focus();
          }
        );
      }
    }
  };

  onDeleteClick = () => {
    if (this.state.formData.edit_expensesrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete this Voucher No. : " +
              this.state.formData.txtVoucherNo +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deletePayment(
                this.state.formData.edit_expensesrno,
                this.props.dtpFromDate,
                this.props.dtpToDate
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  deletePayment = (edit_expensesrno, dtpFromDate, dtpToDate) => {
    if (edit_expensesrno > 0) {
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "DeleteExpense",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          edit_expensesrno: edit_expensesrno,
          dat_fromdate: dtpFromDate,
          dat_todate: dtpToDate,
        };
        fetchPayment(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = 0;
              if (res.data.ExpenseList && res.data.ExpenseList.length > 0) {
                rows = res.data.ExpenseList;
                rowsCount = rows.length;
              }
              this.setState({ ARD: null, dataLoadStatus: true }, () => {
                this.props.refreshPaymentList(rows, rowsCount);
                this.clearInfo();
              });
            } else {
              this.setState({ dataLoadStatus: true });
            }
          })
          .catch((error) => {
            this.props.updateProcessing(
              "error",
              "Unknown error occurred in deletePayment. " + error
            );
          });
      });
    } else {
      this.props.notifyProcessing();
      this.props.updateProcessing(
        "error",
        "There are no receipt records to delete."
      );
    }
  };

  setSaveBtnDisplay = () => {
    let isParamFound =
      this.props &&
      this.props.bint_expensesrno &&
      this.props.bint_expensesrno.length > 0;
    if (isParamFound !== true) {
      isParamFound = false;
    }
    let paramEditExpenseSrNo = 0;
    if (isParamFound) {
      paramEditExpenseSrNo = Number(this.props.bint_expensesrno);
      if (paramEditExpenseSrNo <= 0) {
        isParamFound = false;
      }
    }
    if (this.props.userPrivilege.Payment == "M") {
      return "block";
    } else if (this.props.userPrivilege.Payment == "R") {
      return "none";
    } else if (
      (this.props.userPrivilege.Payment == "W" &&
        Number(this.state.formData.edit_expensesrno) > Number(0) &&
        isParamFound === false) ||
      (this.props.userPrivilege.Payment == "W" &&
        Number(this.state.formData.edit_expensesrno) > Number(0) &&
        isParamFound === true &&
        Number(this.state.formData.edit_expensesrno) !==
          Number(paramEditExpenseSrNo)) ||
      (this.props.userPrivilege.Payment == "W" &&
        Number(this.state.formData.edit_expensesrno) <= Number(0))
    ) {
      return "block";
    } else {
      return "none";
    }
  };

  setPaymentData = (rows) => {
    this.setState(
      {
        rows,
      },
      () => {
        // console.log("this.state.rows", this.state.rows);
      }
    );
  };

  getLedgerList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LedgerNameList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchLedgerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Ledger List Loaded");
        let LedgerGroup = res.data.LedgerNameList;
        let LedgerGroupList = getRowColData(LedgerGroup, "vac_groupname");

        this.setState(
          {
            LedgerGroup,
            LedgerGroupList,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getPurchaseList.", error);
      });
  };

  onAddClickLedger = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<LedgerMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getLedgerList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  openRichTextBox = (Heading, id, TxtChange) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Set"
          fullscreenOnly={true}
          alertIcon=""
          alertTitle={Heading}
          alertMessage={
            <MoreInfoTextEditor
              TxtChange={TxtChange}
              Txtid={id}
              updateDetails={this.updateDetails}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  updateDetails = (id, Details) => {
    let txtRemark = this.state.formData.txtRemark,
      withoutText = Details.replace(/<[^>]*>/g, "").trim();

    if (withoutText.length <= 0) {
      Details = withoutText;
    }

    if (id === "Remark") {
      txtRemark = Details;
    }

    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtRemark,
        },
      },
      () => {}
    );
  };

  hasHtmlFormatting = (text) => {
    if (!text) return false;

    const div = document.createElement("div");
    div.innerHTML = text;

    const cleanedText = text.replace(/<p>\s*<\/p>/gi, "");

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = cleanedText;

    const isVisiblyEmpty = tempDiv.textContent.trim() === "";
    const hasTags = /<[^>]+>/.test(cleanedText);

    const result = !isVisiblyEmpty && hasTags;

    return result;
  };

  //#endregion

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    const displayPaymentNo =
      this.state.formData.edit_expensesrno &&
      Number(this.state.formData.edit_expensesrno) > 0
        ? undefined
        : "none";

    let isSaveBtnDisplay = this.setSaveBtnDisplay();
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Payment Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item state display={displayPaymentNo}>
                <CtTxt
                  id="txtVoucherNo"
                  value={this.state.formData.txtVoucherNo}
                  label="Voucher No"
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={10}
                  disabled={true}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpDate"
                  label="Date"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpDate}
                  value={this.state.formData.dtpDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  nextCtrlID={"cmbLedgerGroup"}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbLedgerGroup"
                  label="Ledger Group"
                  items={this.state.LedgerGroupList}
                  value={this.state.formData.cmbLedgerGroup}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={100}
                  colID="vac_groupname"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbLedger"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbLedger"
                  label="Ledger*"
                  items={this.state.LedgerGroup}
                  value={this.state.formData.cmbLedger}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={300}
                  maxLength={100}
                  dataFilter={
                    this.state.formData.cmbLedger !== this.props.cmbSupplier
                      ? [
                          {
                            filterColID: "vac_groupname",
                            value: this.state.formData.cmbLedgerGroup,
                          },
                        ]
                      : [] // Or provide a default behavior if needed
                  }
                  strictDataFilter={true}
                  colID="vac_ledgername"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtAmount"
                  onAddClick={this.onAddClickLedger}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtAmt
                  id="txtAmount"
                  label="Amount"
                  // disabled={true}
                  value={this.state.formData.txtAmount}
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>
              {/* <Grid item>
                <CtMultiLineText
                  id="txtRemark"
                  label="Remark"
                  value={this.state.formData.txtRemark}
                  handleOnChange={this.handleOnChange}
                  width={300}
                  maxLength={1000}
                />
              </Grid> */}

              {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                <p
                  style={{
                    color: "#666666",
                    margin: "0",
                    padding: "0",
                    fontSize: "14px",
                  }}
                >
                  Remark
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "0",
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.formData.txtRemark,
                    }}
                    style={{ margin: "0", padding: "0" }}
                  />
                  <div style={{ margin: "0", padding: "0" }}>
                    <Edit
                      className={"child-button"}
                      style={{
                        border: "none",
                        cursor: "pointer",
                        // color: "#4687FF",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark
                        );
                      }}
                    />
                  </div>
                </div>
              </Grid> */}

              <Grid item lg={8} md={8} sm={12} xs={12}>
                {!this.hasHtmlFormatting(this.state.formData.txtRemark) ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <CtMultiLineText
                        id="txtRemark"
                        label="Remark"
                        value={this.state.formData.txtRemark}
                        handleOnChange={this.handleOnChange}
                        width="100%"
                        maxLength={1000}
                        // onKeyDown={this.props.onKeyDown}
                      />
                    </div>
                    <Edit
                      className="child-button"
                      style={{
                        marginTop: "26px", // aligns with the input field
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#1976d2",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark
                        );
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "4px",
                          color: "#666666",
                          fontSize: "14px",
                          fontWeight: 500,
                        }}
                      >
                        Remark
                      </label>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.formData.txtRemark,
                        }}
                        style={{
                          minHeight: "100px",
                          padding: "8px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          background: "#f9f9f9",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          lineHeight: "1.5",
                          fontFamily:
                            "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        }}
                      />
                    </div>
                    <Edit
                      className="child-button"
                      style={{
                        marginTop: "26px", // aligns with the top of remark box
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#1976d2",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark
                        );
                      }}
                    />
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <PaymentModeTable
          DefaultEntrySettingList={this.state.defaultSetting}
          PaymentData={this.state.PaymentData}
          PaymentLedgerNameList={this.state.rows}
          Edit_SrNo={this.state.formData.edit_expensesrno}
          setPaymentData={this.setPaymentData}
          txtAmount={this.state.formData.txtAmount}
        />

        {/* <TableList
          columns={this.state.columns1}
          counter={this.state.counter}
          rows={rows}
          onKeyDown={this.props.onKeyDown}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          // actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          // provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          handleOnRowDataChange={this.handleOnRowDataChange}
          // toolTipNewEntry='New Product Entry'
        /> */}
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item display={isSaveBtnDisplay}>
            <CtBtn
              id="savePayment"
              label="Save"
              onClick={() => {
                this.trimFormData(() => {
                  this.SavePayment();
                });
              }}
            />
          </Grid>
          <Grid item display={isSaveBtnDisplay}>
            <CtBtn
              label="Print"
              onClick={() => {
                this.trimFormData(() => {
                  this.SavePayment(true);
                });
              }}
            />
          </Grid>
          <Grid item>
            <CtBtn label="New" onClick={this.clearInfo} variant="outlined" />
          </Grid>
          <Grid
            item
            display={
              this.props.userPrivilege.Payment !== "M" ? "none" : "block"
            }
          >
            <CtBtn
              label="Delete"
              onClick={this.onDeleteClick}
              disabled={
                Number(this.state.formData.edit_expensesrno) > 0 ? false : true
              }
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(PaymentEntry))));
